import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const ArrowLeftSimple = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, ...rest }, ref) => {
    return (
      <svg
        width={size ?? 20}
        height={size ?? 20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.60001 4.94166C8.60001 5.09999 8.54168 5.25833 8.41668 5.38333L3.80001 9.99999L8.41668 14.6167C8.65835 14.8583 8.65835 15.2583 8.41668 15.5C8.17501 15.7417 7.77501 15.7417 7.53335 15.5L2.47501 10.4417C2.23335 10.2 2.23335 9.79999 2.47501 9.55833L7.53335 4.49999C7.77501 4.25833 8.17501 4.25833 8.41668 4.49999C8.54168 4.61666 8.60001 4.78333 8.60001 4.94166Z"
          fill={color}
        />
        <path
          d="M17.7084 10C17.7084 10.3417 17.425 10.625 17.0834 10.625L3.05835 10.625C2.71668 10.625 2.43335 10.3417 2.43335 10C2.43335 9.65833 2.71668 9.375 3.05835 9.375L17.0834 9.375C17.425 9.375 17.7084 9.65833 17.7084 10Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default ArrowLeftSimple;
